export default "__VITE_ASSET__JT9QDFwJ__"